import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">Jaikon Refrigeration India Private Limited</h1>
        <p className="hero-subtitle">Innovative &  Integrated Cold Chain Solutions Provider</p>
        <a href="#about" className="hero-button">Learn More</a>
      </div>
    </section>
  );
};

export default Hero;
